// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-E":"E_shp2-detail-E__Y1sCE"};